import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/soon/soon.module').then(
        (m) => m.SoonModule
      ),
  },
  {
    path: ':accountSlug',
    children: [
      //Account Multi Store IView
      {
        path: '',
        loadChildren: () =>
          import('./layout/stores-layout/stores-layout.module').then(
            (m) => m.StoresLayoutPageModule
          ),
      },
      //Single Store IView
      {
        path: ':shopSlug',
        loadChildren: () =>
          import('./layout/store-layout/store-layout.module').then(
            (m) => m.StoreLayoutPageModule
          ),
      },
    ],
  },
  {
    path: '404',
    loadChildren: () =>
      import('./features/not-found/not-found.module').then(
        (m) => m.NotFoundModule
      ),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      urlUpdateStrategy: 'eager',
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
